
export default function () {
	document.addEventListener('DOMContentLoaded', () => {
		// @ts-expect-error
		const $ = jQuery;
		const toggleButton = document.getElementById('desktop-search-button');
		// 虫眼鏡ボタン.
		if (toggleButton) {
			toggleButton.addEventListener('click', () => {
				// 検索フォーム幅設定.
				const menuWidth = document.getElementById('global-menu__list')?.clientWidth;
				if(menuWidth) {
					$('.desktop-search-form .search-form').width(menuWidth);
				}
				// フォーム表示.
				const searchForm = document.getElementById('desktop-search-form');
				if (searchForm) {
					$(searchForm).fadeToggle(300);
					$('.desktop-search-form .search-field').focus();
				}
			});
		}

	});
}
